<template lang="pug">
with-actions(
  v-on="$listeners"
)
  subheader Уважаемые участники большой олимпиады,&nbsp;
    | информируем Вас об актуальных сроках муниципального этапа:
  ul.list.list--gap-sm.text-body-1.mt-4
    li Срок выполнения заданий и отправки результата&nbsp;
      span.font-weight-bold до 11 мая 12:00 (МСК)
    li Проверка работ экспертами&nbsp;
      span.font-weight-bold с 1 по 15 мая

  subheader.mt-6 Инструкции для муниципального этапа:
  ol.list.text-body-1.mt-4
    li Все задания Муниципального этапа опубликованы в личных кабинетах участников школьных команд.
      ol.list.list--gap-sm.text-body-1
        li Локальный оператор может получить доступ заданиям через управление локальным мероприятием.
        li Капитан команды может получить доступ к командным заданиям следуя&nbsp;
          | #[a(href="https://disk.yandex.ru/i/Nfentb8C5q3mOQ" target="_blank").link Инструкциям]
          ol.list.list--gap-sm.text-body-1
            li Если вы не знаете кто капитан школьной команды, то обратитесь к данной&nbsp;
              | #[a(href="https://disk.yandex.ru/i/aDUvsQ_7nxo_8g" target="_blank").link Инструкции]
        li Участник команды может получить доступ к заданиями следуя&nbsp;
          | #[a(href="https://disk.yandex.ru/i/seCuhtQWIChc2g" target="_blank").link Инструкции]
    li К каждому заданию прилагаются рекомендации по выполнению заданий.&nbsp;
      | Они размещены в конце каждого задания в виде ссылок.
    li К каждому заданию прилагаются рекомендации по использованию цифровых сервисов.&nbsp;
      | Они размещены в конце каждого задания в виде ссылок.
    li В связи с имеющимся риском блокировки зарубежных интернет-ресурсов.&nbsp;
      | Организаторами олимпиады принято решение использовать для публикации результатов заданий Yandex ZEN.
      ol.list.list--gap-sm.text-body-1
        li В связи с этим школе необходимо зарегистрировать общий командный акканут&nbsp;
          | согласно следующей #[a(href="https://disk.yandex.ru/i/1d2kyT-qVPudZg" target="_blank").link Инструкции]
        li Для загрузки творческих работ с результатом в виде текста используйте данную&nbsp;
          | #[a(href="https://disk.yandex.ru/i/6niIgb6nzII1Yg" target="_blank").link Инструкцию]
        li Для загрузки творческих работ с результатов в виде изображения используйте&nbsp;
          | данную #[a(href="https://disk.yandex.ru/i/kVjjHQ3F3PlZQg" target="_blank").link Инструкцию]
        li Для загрузки творческих работ с результатом в виде видеофайла используйте&nbsp;
          | данную #[a(href="https://disk.yandex.ru/i/Wv-dMfkouUn9wg" target="_blank").link Инструкцию]
</template>

<script>
import WithActions from '../components/WithActions.vue';
import Subheader from '../components/Subheader.vue';

export default {
  name: 'OrganizationWelcomeVcht',
  components: {
    WithActions,
    Subheader,
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
ol {
  counter-reset: item;

  &:not(:first-child):has(ol) {
    padding-left: 0 !important;
  }

  li {
    display: block;

    &::before {
      content: counters(item, '.') '. ';
      counter-increment: item;
    }
  }
}
</style>
